import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { environment } from 'src/environments/environment';

import { AuthService } from '../core/auth.service';
import { UserClientInput } from '../model.ts/user.model';
import { PersonInput } from '../model.ts/person.model';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    constructor(
        private apollo: Apollo,
        private http: HttpClient,
        private auth: AuthService
    ) { }

    PERSON_BY_USERNAME = gql`
        query findPersonByUserName($username: String!) {
            findPersonByUserName(username: $username) {
                id
                fullName
                dni
                email
                active
                referenceId
                phone
                identificationType
                user {
                    id
                    userName
                    password
                    pin
                    warehouse {
                        id
                        name
                        referenceId
                        active
                        establishment {
                            id
                            name
                            address
                            number
                            referenceId
                        }
                    }
                    active
                    resetPassword
                    roles {
                        id
                        name
                        active
                        permissions {
                            id
                            name
                            domainAction
                            active
                        }
                    }
                    oldPassword
                    createdAt
                    updatedAt
                    createdBy
                    updatedBy
                }
                userName
                createdAt
                updatedAt
                createdBy
                updatedBy
            }
        }
    `;

    GET_USER_CUSTOMER = gql`
    query usersClient($page: Int!, $size: Int!, $value: String, $active: Boolean!) {
        usersClient(page: $page, size: $size, value: $value, active: $active)  {
          page
          size
          totalElements
          totalPages
          data {
            id
            userName
            password
            dni
            referenceId
            priceList
            active
            fullName
          }
        }
      }
    `;
    USER_CLIENT_BY_ID = gql`
        query userClientById($id: String!) {
            userClientById(id: $id) {
                id
                userName
                password
                dni
                fullName
                active
                roles {
                    id
                    name
                    active
                    permissions {
                        id
                        name
                        domainAction
                        active
                    }
                }
                referenceId
                priceList
            }
        }`;
    USER_WITH_CUSTOMER_DISCOUNT_LIST_BY_ID = gql`
        query userWithCustomerDiscountListById($id: String!) {
            userWithCustomerDiscountListById(id: $id) {
                dni
                fullName
                active
                referenceId
                discountList
            }
        }`;
    SAVE_USER_CLIENT = gql`
             mutation saveUserClient($userClientInput: UserClientInput!){
                saveUserClient(userClientInput: $userClientInput){
                      id
                      userName
                      password
                      dni
                      referenceId
                      priceList
                  }
               }
        `;

    SAVE_CLIENT = gql`
             mutation saveClient($referenceId: String!, $discountListReferenceId: [String]!){
                saveClient(referenceId: $referenceId, discountListReferenceId: $discountListReferenceId)
               }
        `;

    omitTypename(key, value) {
        return key === '__typename' ? undefined : value;
    }

    omitType(model) {
        return JSON.parse(JSON.stringify(model), this.omitTypename);
    }

    doLoginRest(userName: string, password: string, system: string) {
        return this.http.post(
            environment.apiUrl + '/login',
            JSON.stringify({ userName, password, system })
        );
    }

    getCurrentPerson() {
        const username = this.auth.getCurrentSub();
        return this.apollo.query<any>({
            query: this.PERSON_BY_USERNAME,
            variables: { username },
        });
    }
    getPersonByUserName(username: string) {
        return this.apollo.query<any>({
            query: this.PERSON_BY_USERNAME,
            variables: { username },
        });
    }
    listUsersByStatus(
        page: number,
        size: number,
        value: string,
        active: boolean
    ) {
        return this.apollo.query<any>({
            query: this.GET_USER_CUSTOMER,
            variables: { page, size, value, active },
        });
    }

    userClientById(id: string) {
        return this.apollo.query<any>({
            query: this.USER_CLIENT_BY_ID,
            variables: { id },
        });
    }

    userWithCustomerDiscountListById(id: string) {
        return this.apollo.query<any>({
            query: this.USER_WITH_CUSTOMER_DISCOUNT_LIST_BY_ID,
            variables: { id },
        });
    }

    saveUserClient(userClientInput: UserClientInput) {
        return this.apollo.mutate({
            mutation: this.SAVE_USER_CLIENT,
            variables: { userClientInput },
        });
    }

    saveClient(referenceId: string, discountListReferenceId: string[]) {
        return this.apollo.mutate({
            mutation: this.SAVE_CLIENT,
            variables: { referenceId, discountListReferenceId },
        });
    }
}
